export default __webpack_public_path__ + "static/media/logo2.941c0726.png";